import { takeLatest, put, call } from "redux-saga/effects";

import { GET_SETTINGS,SAVE_SETTINGS,UPLOAD_FILE,GET_DOCS,DEL_DOC} from "./actionTypes";

import {
  getSettingsFail,
  getSettingsSuccess,
  saveSettingsFail,
  saveSettingsSuccess,
  uploadFileFailure,
  uploadFileSuccess,
  getDocsFail,
  getDocsSuccess,
  delDocFailure,
  delDocSuccess
  
} from "./actions";

import { getSettings,saveSettings,uploadFile,getAdminDocs,delAdminDoc} from "../../helpers/backend_helper";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function* onDelDoc({ payload: data,token }) {

  
  try {
    const response = yield call(delAdminDoc,data,token);
    console.log(response);
    yield put(delDocSuccess(response.data));
  } catch (error) {
    yield put(delDocFailure(error.response));
  }
}
function* onGetDocs() {

  
  try {
    const response = yield call(getAdminDocs);
    console.log(response);
  
    yield put(getDocsSuccess(response.data));
  } catch (error) {
    yield put(getDocsFail(error.response.data));
  }
}

function* onGetSettings({token}) {

  
  try {
    const response = yield call(getSettings,token);
    console.log(response);
  
    yield put(getSettingsSuccess(response.data));
  } catch (error) {
    yield put(getSettingsFail(error.response.data));
  }
}

function* onSaveSettings({ payload: data,token }) {

  
  try {
    const response = yield call(saveSettings,data,token);
   // console.log(response);
    toast(response.message);
    yield put(saveSettingsSuccess(response.data));
  } catch (error) {
    toast(error.response.data.data);
    yield put(saveSettingsFail(error.response));
  }
}

function* onUploadFile({ payload: data,token,navigate }) {

  
  try {
    const response = yield call(uploadFile,data,token);
    console.log(response);
    toast(response.message);
      yield put(uploadFileSuccess(response.data));
  } catch (error) {
  //  toast(error.response.data.message);
    yield put(uploadFileFailure(error.response));
  }
}

function* SettingsSaga() {

  yield takeLatest(SAVE_SETTINGS, onSaveSettings);
  yield takeLatest(GET_SETTINGS, onGetSettings);
  yield takeLatest(UPLOAD_FILE, onUploadFile);
  yield takeLatest(GET_DOCS, onGetDocs);
  yield takeLatest(DEL_DOC, onDelDoc);

}

export default SettingsSaga;
